export default __webpack_public_path__ + "static/media/icon-youtube.ef414cf2.svg";